// import React, { useState } from "react";
// import Select from "react-select";
// import DatePicker from "react-datepicker";


// const options = [
//     { value: "dashboard", label: "Dashboard" },
//     { value: "team", label: "My Team" },
//     { value: "buildings", label: "Buildings" },
//     { value: "reports", label: "Reports" },
// ];

// const CreateBuilding = () => {
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [validFrom, setValidFrom] = useState(null);
//     const [validTo, setValidTo] = useState(null);

//     return (
//         <div className="admin-page">
//             <div className="back-title d-flex align-items-center">
//                 <button className="back-btn-title"><i className="icon-icon-11"></i></button>
//                 <h3 className="page-section-title">Create Building</h3>
//             </div>
//             <div className="create-building-form">
//                 <div className="row">
//                     <div className="col-md-6">
//                         <div className="form-group">
//                             <label>Building Name</label>
//                             <input type="text" class="form-control" placeholder="Enter building name" />
//                         </div>
//                     </div>
//                     <div className="col-md-6">
//                         <div className="form-group">
//                             <label>Owner Name</label>
//                             <input type="text" class="form-control" placeholder="Enter Owner name" />
//                         </div>
//                     </div>
//                     <div className="col-md-6">
//                         <div className="form-group">
//                             <label>Property Type</label>
//                             <div className="custom-select">
//                                 <Select
//                                     options={options}
//                                     value={selectedOption}
//                                     onChange={setSelectedOption}
//                                     placeholder="Select property type"
//                                     isClearable
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="col-md-6">
//                         <div className="form-group">
//                             <label>Property Size</label>
//                             <div className="custom-select">
//                                 <Select
//                                     options={options}
//                                     value={selectedOption}
//                                     onChange={setSelectedOption}
//                                     placeholder="Select property size"
//                                     isClearable
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="col-md-6">
//                         <div className="form-group">
//                             <label>Valid from</label>
//                             <div className="date-picker">
//                                 <DatePicker
//                                     selected={validFrom}
//                                     onChange={(date) => setValidFrom(date)}
//                                     className="form-control"
//                                     placeholderText="Select start date"
//                                     dateFormat="MM/dd/yyyy"
//                                 />
//                                 <span className="icon"><i className="icon-icon-13"></i></span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="col-md-6">
//                         <div className="form-group">
//                             <label>Valid to</label>
//                             <div className="date-picker">
//                                 <DatePicker
//                                     selected={validTo}
//                                     onChange={(date) => setValidTo(date)}
//                                     className="form-control"
//                                     placeholderText="Select end date"
//                                     dateFormat="MM/dd/yyyy"
//                                     minDate={validFrom}
//                                 />
//                                 <span className="icon"><i className="icon-icon-13"></i></span>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="col-12">
//                         <div className="form-group">
//                             <label>Property Address</label>
//                             <textarea class="form-control" placeholder="Enter property address" />
//                         </div>
//                     </div>
//                     <div className="col-12">
//                         <div className="form-group">
//                             <label>Building Address</label>
//                             <textarea class="form-control" placeholder="Enter building address" />
//                         </div>
//                     </div>
//                     <div className="col-12">
//                         <div className="form-group">
//                             <label>Managing Address</label>
//                             <textarea class="form-control" placeholder="Enter managing address" />
//                         </div>
//                     </div>
//                     <div className="button-group d-flex align-items-center">
//                         <button className="btns">Add Building</button>
//                         <button className="btns cancel-btns">Cancel</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default CreateBuilding;


import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import EnergyMappingEditor from "../../components/energyMapping/EnergyMappingEditor";

const propertyTypes = [
  { value: "office", label: "Office" },
  { value: "retail", label: "Retail" },
  { value: "warehouse", label: "Warehouse" },
  { value: "residential", label: "Residential" },
];

const propertySizes = [
  { value: "small", label: "Small" },
  { value: "medium", label: "Medium" },
  { value: "large", label: "Large" },
];

// Client 2026-09-11. Only "Active" counts in the Dashboard totals; "Inactive"
// (contract ended) and "Training" (a duplicate used for training) behave the same
// way and differ only by label. The building stays fully usable in every case.
const statusChoices = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "training", label: "Training" },
];

const ALLOWED_LOGO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];
const MAX_LOGO_SIZE = 5 * 1024 * 1024;

const buildValidationSchema = (requireDates) =>
  Yup.object().shape({
    building_name: Yup.string().required("Building name is required"),
    owner_name: Yup.string().required("Owner name is required"),
    property_type: Yup.object().nullable().required("Property type is required"),
    property_size: Yup.object().nullable().required("Property size is required"),
    property_address: Yup.string().required("Property address is required"),
    building_address: Yup.string().required("Building address is required"),
    managing_addresses: Yup.array().test(
      "all-filled",
      "Managing address is required",
      (addresses) => addresses && addresses.every((addr) => addr && addr.trim() !== "")
    ),
    valid_from: requireDates
      ? Yup.date().nullable().required("Valid from date is required")
      : Yup.date().nullable(),
    valid_to: requireDates
      ? Yup.date().nullable().min(Yup.ref("valid_from"), "Valid to must be after valid from").required("Valid to date is required")
      : Yup.date().nullable(),
    white_labelling: Yup.boolean(),
    acomptes_enabled: Yup.boolean(),
    // Phase 4 "Résultat détaillé" toggles. BUILDING-scoped (all periods) —
    // unlike white_labelling/acomptes_enabled above, which are per-period.
    detail_module_enabled: Yup.boolean(),
    detail_object_enabled: Yup.boolean(),
    detail_tenant_enabled: Yup.boolean(),
    // Client 2026-08-08: "Graphiques" — also BUILDING-scoped, so it sits in this group.
    graph_enabled: Yup.boolean(),
    status: Yup.object().nullable(),
    logo_file: Yup.mixed().nullable(),
  });

const CreateBuilding = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isEdit = Boolean(id);
  const copyFromPeriodIdFromQuery = Number(searchParams.get("copyFromPeriodId"));
  const isPeriodCopyFlow = Number.isFinite(copyFromPeriodIdFromQuery) && copyFromPeriodIdFromQuery > 0;

  // Date pickers are shown in create mode and copy-period mode; hidden in regular edit mode
  const showDatePickers = !isEdit || isPeriodCopyFlow;

  const [periodOptions, setPeriodOptions] = useState([]);
  const [selectedCopyPeriod, setSelectedCopyPeriod] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(null); // regular edit period dropdown
  const [existingLogoUrl, setExistingLogoUrl] = useState(null); // current logo of selected period
  const [logoPreview, setLogoPreview] = useState(null);
  const [clearLogo, setClearLogo] = useState(false);
  const [logoError, setLogoError] = useState(null);
  const fileInputRef = useRef(null);

  const clearFileInput = () => {
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const validationSchema = buildValidationSchema(showDatePickers);

  const [initialValues, setInitialValues] = useState({
    building_name: "",
    owner_name: "",
    property_type: null,
    property_size: null,
    valid_from: null,
    valid_to: null,
    property_address: "",
    building_address: "",
    managing_addresses: [""],
    white_labelling: false,
    acomptes_enabled: true,
    // Défaults mirror the DB column defaults so a new building produces exactly
    // today's report: objet ON, module + locataire OFF.
    detail_module_enabled: false,
    detail_object_enabled: true,
    detail_tenant_enabled: false,
    graph_enabled: true,
    // Defaults to Active so a newly created building behaves exactly as before.
    status: statusChoices[0],
    logo_file: null,
  });

  // Fetch existing building in edit mode
  useEffect(() => {
    if (isEdit) {
      const fetchBuilding = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}building/details/${id}`,
            {
              headers: {
                "api-key": process.env.REACT_APP_API_KEY,
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (res.data.status === "success") {
            const b = res.data.data;

            // Build period options including per-period white_labelling and logo
            const options = (b.periods || []).map((period, index) => {
              const from = period.start_date
                ? new Date(period.start_date).toLocaleDateString("en-GB")
                : "-";
              const to = period.end_date
                ? new Date(period.end_date).toLocaleDateString("en-GB")
                : "-";
              return {
                value: period.id,
                label: `Period ${index + 1}: ${from} to ${to}`,
                white_labelling: period.white_labelling || false,
                acomptes_enabled: period.acomptes_enabled ?? true,
                logo: period.logo || null,
              };
            });
            setPeriodOptions(options);

            if (isPeriodCopyFlow) {
              const preselectedOption = options.find(
                (opt) => opt.value === copyFromPeriodIdFromQuery
              );
              setSelectedCopyPeriod(preselectedOption || null);
            } else {
              // Regular edit: auto-select first period, load its white_labelling/logo
              const firstPeriod = options[0] || null;
              setSelectedPeriod(firstPeriod);
              setExistingLogoUrl(firstPeriod?.logo || null);
            }

            const firstPeriod = b.periods?.[0];
            setInitialValues({
              building_name: b.building_name || "",
              owner_name: b.owner_name || "",
              property_type:
                propertyTypes.find((pt) => pt.value === b.property_type) || null,
              property_size:
                propertySizes.find((ps) => ps.value === b.building_size) || null,
              valid_from: firstPeriod?.start_date ? new Date(firstPeriod.start_date) : null,
              valid_to: firstPeriod?.end_date ? new Date(firstPeriod.end_date) : null,
              property_address: b.property_address || "",
              building_address: b.building_address || "",
              managing_addresses: b.managing_address
                ? b.managing_address.split("||")
                : [""],
              // Load white_labelling from first period (regular edit), not from building
              white_labelling: isPeriodCopyFlow ? false : (firstPeriod?.white_labelling || false),
              // Load acomptes_enabled from first period; defaults to true (opt-out flag)
              acomptes_enabled: isPeriodCopyFlow ? true : (firstPeriod?.acomptes_enabled ?? true),
              // Phase 4 détaillé toggles come from the BUILDING (`b`), not from a
              // period — so unlike white_labelling above they are NOT reset in the
              // copy-period flow: copying a period must not silently change which
              // detailed reports the building produces.
              detail_module_enabled: b.detail_module_enabled ?? false,
              detail_object_enabled: b.detail_object_enabled ?? true,
              detail_tenant_enabled: b.detail_tenant_enabled ?? false,
              graph_enabled: b.graph_enabled ?? true,
              status: statusChoices.find((o) => o.value === String(b.status || 'active').toLowerCase())
                || statusChoices[0],
              logo_file: null,
            });
          }
        } catch (err) {
          console.error("Error fetching building:", err);
        }
      };
      fetchBuilding();
    }
  }, [isEdit, id, searchParams, isPeriodCopyFlow, copyFromPeriodIdFromQuery]);

  // When user selects a different period in regular edit mode
  const handlePeriodSelect = (opt, setFieldValue) => {
    setSelectedPeriod(opt);
    setFieldValue("white_labelling", opt?.white_labelling || false);
    setFieldValue("acomptes_enabled", opt?.acomptes_enabled ?? true);
    // NOTE: the détaillé toggles are deliberately NOT reloaded here. They belong
    // to the building, not the period, so switching the period dropdown must
    // leave them exactly as they are.
    setExistingLogoUrl(opt?.logo || null);
    setLogoPreview(null);
    setFieldValue("logo_file", null);
    clearFileInput();
    setClearLogo(false);
    setLogoError(null);
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const headers = {
        "api-key": process.env.REACT_APP_API_KEY,
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      let payload;
      let uploadPeriodId = null;
      let uploadBuildingId = id;

      if (!isEdit) {
        // CREATE: white_labelling applies to the new period
        payload = {
          building_name: values.building_name,
          owner_name: values.owner_name,
          property_type: values.property_type.value,
          property_size: values.property_size.value,
          property_address: values.property_address,
          building_address: values.building_address,
          managing_address: values.managing_addresses.join("||"),
          white_labelling: values.white_labelling,
          acomptes_enabled: values.acomptes_enabled,
          // Building-scoped détaillé toggles (top level, never inside `periods`).
          detail_module_enabled: values.detail_module_enabled,
          detail_object_enabled: values.detail_object_enabled,
          detail_tenant_enabled: values.detail_tenant_enabled,
          graph_enabled: values.graph_enabled,
          status: values.status?.value || "active",
          periods: [{
            valid_from: values.valid_from
              ? new Date(values.valid_from.getTime() - values.valid_from.getTimezoneOffset() * 60000).toISOString().split("T")[0]
              : null,
            valid_to: values.valid_to
              ? new Date(values.valid_to.getTime() - values.valid_to.getTimezoneOffset() * 60000).toISOString().split("T")[0]
              : null,
            white_labelling: values.white_labelling,
            acomptes_enabled: values.acomptes_enabled,
          }],
        };
      } else if (isPeriodCopyFlow) {
        // COPY-PERIOD: adding a new period with white_labelling
        payload = {
          id,
          building_name: values.building_name,
          owner_name: values.owner_name,
          property_type: values.property_type.value,
          property_size: values.property_size.value,
          property_address: values.property_address,
          building_address: values.building_address,
          managing_address: values.managing_addresses.join("||"),
          period_white_labelling: values.white_labelling,
          period_acomptes_enabled: values.acomptes_enabled,
          // Building-scoped détaillé toggles — sent on the copy-period flow too,
          // carrying the values loaded from the building so copying a period
          // never changes which detailed reports it produces.
          detail_module_enabled: values.detail_module_enabled,
          detail_object_enabled: values.detail_object_enabled,
          detail_tenant_enabled: values.detail_tenant_enabled,
          graph_enabled: values.graph_enabled,
          status: values.status?.value || "active",
          periods: [{
            valid_from: values.valid_from
              ? new Date(values.valid_from.getTime() - values.valid_from.getTimezoneOffset() * 60000).toISOString().split("T")[0]
              : null,
            valid_to: values.valid_to
              ? new Date(values.valid_to.getTime() - values.valid_to.getTimezoneOffset() * 60000).toISOString().split("T")[0]
              : null,
            white_labelling: values.white_labelling,
            acomptes_enabled: values.acomptes_enabled,
          }],
          ...(selectedCopyPeriod?.value ? { copy_from_period_id: selectedCopyPeriod.value } : {}),
        };
      } else {
        // REGULAR EDIT: update building fields + selected period's white_labelling
        payload = {
          id,
          building_name: values.building_name,
          owner_name: values.owner_name,
          property_type: values.property_type.value,
          property_size: values.property_size.value,
          property_address: values.property_address,
          building_address: values.building_address,
          managing_address: values.managing_addresses.join("||"),
          // Building-scoped détaillé toggles — outside the selected_period_id
          // block on purpose: they apply to every period, so they are saved even
          // when no period is selected.
          detail_module_enabled: values.detail_module_enabled,
          detail_object_enabled: values.detail_object_enabled,
          detail_tenant_enabled: values.detail_tenant_enabled,
          graph_enabled: values.graph_enabled,
          status: values.status?.value || "active",
          ...(selectedPeriod?.value ? {
            selected_period_id: selectedPeriod.value,
            period_white_labelling: values.white_labelling,
            period_acomptes_enabled: values.acomptes_enabled,
            ...(!values.white_labelling || clearLogo ? { clear_period_logo: true } : {}),
          } : {}),
        };
        uploadPeriodId = selectedPeriod?.value || null;
      }

      const url = isEdit
        ? `${process.env.REACT_APP_API_URL}building/update`
        : `${process.env.REACT_APP_API_URL}building/create`;

      const res = await axios.post(url, payload, { headers });

      if (res.data.status !== "success") {
        alert(res.data.data || res.data.message || "Failed to save building");
        return;
      }

      // Determine which building + period to upload logo to
      if (!isEdit) {
        uploadBuildingId = res.data.data?.id;
        uploadPeriodId = res.data.data?.period_id;
      } else if (isPeriodCopyFlow) {
        uploadPeriodId = res.data.data?.new_period_id;
      }

      // Upload logo if white_labelling is ON, a new file was selected, and we have a period ID
      if (values.white_labelling && values.logo_file && uploadBuildingId && uploadPeriodId) {
        const formData = new FormData();
        formData.append("logo", values.logo_file);
        try {
          await axios.post(
            `${process.env.REACT_APP_API_URL}building/${uploadBuildingId}/period/${uploadPeriodId}/upload-logo`,
            formData,
            { headers: { ...headers, "Content-Type": "multipart/form-data" } }
          );
        } catch (uploadErr) {
          console.warn("Logo upload failed:", uploadErr);
          const errMsg =
            uploadErr?.response?.data?.message ||
            uploadErr?.response?.data?.data ||
            uploadErr?.message ||
            'Unknown error';
          alert(`Building saved, but logo upload failed: ${errMsg}. You can re-upload by editing the building.`);
          resetForm();
          navigate("/buildings");
          return;
        }
      }

      resetForm();
      navigate("/buildings");
    } catch (err) {
      console.error("Error saving building:", err);
      alert(
        err?.response?.data?.data ||
        err?.response?.data?.message ||
        "Failed to save building"
      );
    }
  };

  return (
    <div className="admin-page">
      <div className="back-title d-flex align-items-center gap-2">
        <button className="back-btn-title" onClick={() => navigate("/buildings")}>
          <i className="icon-icon-11"></i>
        </button>
        <h3 className="page-section-title">
          {isEdit ? "Edit Building" : "Create Building"}
        </h3>
        {isEdit && isPeriodCopyFlow && (
          <span className="period-copy-badge" title="Copy Period mode is enabled for the selected source period">
            Copy Period Mode
          </span>
        )}
      </div>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form className="create-building-form form-full-width">
            <div className="row">
              {/* Building Name */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Building Name</label>
                  <Field name="building_name" className="form-control" placeholder="Enter building name" />
                  <ErrorMessage name="building_name" component="div" className="text-danger" />
                </div>
              </div>

              {/* Owner Name */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Owner Name</label>
                  <Field name="owner_name" className="form-control" placeholder="Enter owner name" />
                  <ErrorMessage name="owner_name" component="div" className="text-danger" />
                </div>
              </div>

              {/* Property Type */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Property Type</label>
                  <div className="custom-select">
                    <Select
                      options={propertyTypes}
                      value={values.property_type}
                      onChange={(opt) => setFieldValue("property_type", opt)}
                      placeholder="Select property type"
                    />
                  </div>
                  <ErrorMessage name="property_type" component="div" className="text-danger" />
                </div>
              </div>

              {/* Property Size */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Property Size</label>
                  <div className="custom-select">
                    <Select
                      options={propertySizes}
                      value={values.property_size}
                      onChange={(opt) => setFieldValue("property_size", opt)}
                      placeholder="Select property size"
                    />
                  </div>
                  <ErrorMessage name="property_size" component="div" className="text-danger" />
                </div>
              </div>

              {/* Property Status — only "Active" counts in the Dashboard totals */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Status</label>
                  <div className="custom-select">
                    <Select
                      options={statusChoices}
                      value={values.status}
                      onChange={(opt) => setFieldValue("status", opt)}
                      placeholder="Select status"
                    />
                  </div>
                  <small className="text-muted">
                    Inactive and Training properties stay fully usable but are excluded
                    from the Dashboard totals.
                  </small>
                </div>
              </div>

              {/* Period dropdown — regular edit mode only */}
              {isEdit && !isPeriodCopyFlow && periodOptions.length > 0 && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Period</label>
                    <div className="custom-select">
                      <Select
                        options={periodOptions}
                        value={selectedPeriod}
                        onChange={(opt) => handlePeriodSelect(opt, setFieldValue)}
                        placeholder="Select period"
                        isClearable={false}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Valid From / Valid To — create and copy-period mode only */}
              {showDatePickers && (
                <>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Valid from</label>
                      <div className="date-picker">
                        <DatePicker
                          selected={values.valid_from}
                          onChange={(date) => setFieldValue("valid_from", date)}
                          className="form-control"
                          placeholderText="Select start date"
                          dateFormat="dd/MM/yyyy"
                        />
                        <span className="icon"><i className="icon-icon-13"></i></span>
                      </div>
                      <ErrorMessage name="valid_from" component="div" className="text-danger" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Valid to</label>
                      <div className="date-picker">
                        <DatePicker
                          selected={values.valid_to}
                          onChange={(date) => setFieldValue("valid_to", date)}
                          className="form-control"
                          placeholderText="Select end date"
                          minDate={values.valid_from}
                          dateFormat="dd/MM/yyyy"
                        />
                        <span className="icon"><i className="icon-icon-13"></i></span>
                      </div>
                      <ErrorMessage name="valid_to" component="div" className="text-danger" />
                    </div>
                  </div>
                </>
              )}

              {/* Copy Source Period — copy-period mode only */}
              {isEdit && isPeriodCopyFlow && periodOptions.length > 0 && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Copy Period From</label>
                    <div className="custom-select">
                      <Select
                        options={periodOptions}
                        value={selectedCopyPeriod}
                        onChange={setSelectedCopyPeriod}
                        placeholder="Select source period"
                        isClearable={false}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Property Address */}
              <div className="col-12">
                <div className="form-group">
                  <label>Property Address</label>
                  <Field as="textarea" name="property_address" className="form-control" placeholder="Enter property address" />
                  <ErrorMessage name="property_address" component="div" className="text-danger" />
                </div>
              </div>

              {/* Building Address */}
              <div className="col-12">
                <div className="form-group">
                  <label>Building Address</label>
                  <Field as="textarea" name="building_address" className="form-control" placeholder="Enter building address" />
                  <ErrorMessage name="building_address" component="div" className="text-danger" />
                </div>
              </div>

              {/* Managing Address (Dynamic) */}
              <div className="col-12">
                <div className="form-group">
                  <div className="managing-lable d-flex align-items-center justify-content-between gap-2">
                    <label className="mb-0">Managing Address</label>
                  </div>
                  <FieldArray name="managing_addresses">
                    {({ push, remove }) => (
                      <>
                        {values.managing_addresses.map((addr, idx) => (
                          <div key={idx} className="form-group d-flex mb-2 managing-input flex-column">
                            {values.managing_addresses.length > 1 && (
                              <button
                                type="button"
                                className="btn-text d-flex align-items-center remove-btn mb-1 justify-content-end ml-auto"
                                onClick={() => remove(idx)}
                              >
                                <span className="icon d-flex"><i className="icon-icon-14"></i></span>
                                Remove
                              </button>
                            )}
                            <Field
                              as="textarea"
                              name={`managing_addresses[${idx}]`}
                              className="form-control"
                              placeholder="Enter managing address"
                            />
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn-text d-flex align-items-center mt-2"
                          onClick={() => push("")}
                        >
                          <span className="icon d-flex"><i className="icon-icon-5"></i></span> Add more
                        </button>
                        <ErrorMessage name="managing_addresses" component="div" className="text-danger" />
                      </>
                    )}
                  </FieldArray>
                </div>
              </div>

              {/* White Labelling Toggle */}
              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex align-items-center gap-3">
                    <label className="mb-0">White Labelling</label>
                    <div
                      className={`toggle-switch${values.white_labelling ? " active" : ""}`}
                      onClick={() => {
                        const next = !values.white_labelling;
                        setFieldValue("white_labelling", next);
                        if (!next) {
                          setFieldValue("logo_file", null);
                          setLogoPreview(null);
                          setExistingLogoUrl(null);
                          clearFileInput();
                          setClearLogo(true);
                          setLogoError(null);
                        }
                      }}
                      role="switch"
                      aria-checked={values.white_labelling}
                    >
                      <span className="toggle-knob" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Acomptes Toggle — when OFF the report hides Acomptes/Solde
                  columns (Résultats par objet/locataire) and lines (Résultat détaillé) */}
              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex align-items-center gap-3">
                    <label className="mb-0">Acomptes</label>
                    <div
                      className={`toggle-switch${values.acomptes_enabled ? " active" : ""}`}
                      onClick={() => setFieldValue("acomptes_enabled", !values.acomptes_enabled)}
                      role="switch"
                      aria-checked={values.acomptes_enabled}
                    >
                      <span className="toggle-knob" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Résultat détaillé toggles (Phase 4) — pick which detailed
                  reports appear in the final Répartition report. Independent:
                  any combination, including none.

                  SCOPE DIFFERS FROM THE TOGGLES ABOVE and the caption says so
                  out loud: White Labelling and Acomptes apply to the SELECTED
                  PERIOD, these apply to the WHOLE BUILDING (client's explicit
                  request, 28.07.2026). Two adjacent toggle groups behaving
                  differently is exactly the kind of thing that generates "why
                  did my 2024 report change?" support questions, so the
                  difference is stated in the UI rather than left implicit.

                  All three switches are live as of M2 (the locataire report now
                  renders). Each defaults so existing buildings are unchanged:
                  objet ON, module and locataire OFF. */}
              <div className="col-12">
                <div className="form-group">
                  <label className="mb-1">Résultat détaillé</label>
                  <small className="d-block text-muted mb-2">
                    Which detailed reports are included in the final report. Applies to all periods of this building.
                  </small>
                  <div className="d-flex align-items-center gap-3 mb-2">
                    <div
                      className={`toggle-switch${values.detail_module_enabled ? " active" : ""}`}
                      onClick={() => setFieldValue("detail_module_enabled", !values.detail_module_enabled)}
                      role="switch"
                      aria-checked={values.detail_module_enabled}
                      aria-label="Résultat détaillé (module)"
                    >
                      <span className="toggle-knob" />
                    </div>
                    <label className="mb-0">Résultat détaillé (module)</label>
                  </div>
                  <div className="d-flex align-items-center gap-3 mb-2">
                    <div
                      className={`toggle-switch${values.detail_object_enabled ? " active" : ""}`}
                      onClick={() => setFieldValue("detail_object_enabled", !values.detail_object_enabled)}
                      role="switch"
                      aria-checked={values.detail_object_enabled}
                      aria-label="Résultat détaillé (objet)"
                    >
                      <span className="toggle-knob" />
                    </div>
                    <label className="mb-0">Résultat détaillé (objet)</label>
                  </div>
                  {/* Revealed in M2 now that the locataire report renders. Its column
                      has existed since the B1 migration, so no schema change here. */}
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className={`toggle-switch${values.detail_tenant_enabled ? " active" : ""}`}
                      onClick={() => setFieldValue("detail_tenant_enabled", !values.detail_tenant_enabled)}
                      role="switch"
                      aria-checked={values.detail_tenant_enabled}
                      aria-label="Résultat détaillé (locataire)"
                    >
                      <span className="toggle-knob" />
                    </div>
                    <label className="mb-0">Résultat détaillé (locataire)</label>
                  </div>
                </div>
              </div>

              {/* Graphiques (client 2026-08-08) — the Objet/Immeuble bar chart drawn
                  on the Résultat détaillé cost pages.

                  Its own group rather than a fourth switch above, because the three
                  above choose WHICH detailed reports are produced while this one
                  changes WHAT IS ON a detailed page. One switch covers all three
                  variants, as agreed with the client, so it never has to be set
                  three times.

                  Default ON, so no existing report changes until it is turned off.
                  Turning it off is not purely cosmetic: the chart's space returns to
                  the cost lines, so an entry whose costs fit on one page drops from
                  two pages to one. The Excel export is unaffected — charts only ever
                  existed in the PDF. */}
              <div className="col-12">
                <div className="form-group">
                  <label className="mb-1">Graphiques</label>
                  <small className="d-block text-muted mb-2">
                    Include the Objet / Immeuble chart on the Résultat détaillé pages. Applies to all periods of this building. When off, the freed space is used for cost lines, which can reduce the number of pages.
                  </small>
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className={`toggle-switch${values.graph_enabled ? " active" : ""}`}
                      onClick={() => setFieldValue("graph_enabled", !values.graph_enabled)}
                      role="switch"
                      aria-checked={values.graph_enabled}
                      aria-label="Graphiques"
                    >
                      <span className="toggle-knob" />
                    </div>
                    <label className="mb-0">Graphiques</label>
                  </div>
                </div>
              </div>

              {/* Consommations setup (client 2026-09-01, approved as additional work).
                  Building-scoped like the two groups above, so it sits with them.

                  EDIT MODE ONLY, and only once a period is chosen: the editor offers
                  the building's meters / cost accounts / keys to pick from, and none of
                  those exist until the building has been created and its data imported.
                  Showing an empty editor during creation would look broken.

                  It saves through its own endpoint (see the component) rather than this
                  form's submit, so the two saves stay independent. */}
              {isEdit && !isPeriodCopyFlow && selectedPeriod?.value && (
                <EnergyMappingEditor
                  buildingId={id}
                  periodId={selectedPeriod.value}
                  periodLabel={selectedPeriod.label}
                />
              )}

              {/* Logo Upload (visible only when White Labelling is ON) */}
              {values.white_labelling && (
                <div className="col-12">
                  <div className="form-group">
                    <label>Logo <span className="text-muted">(optional)</span></label>

                    {/* Existing logo from selected period */}
                    {existingLogoUrl && !logoPreview && (
                      <div className="logo-preview mb-2 d-flex align-items-center gap-3">
                        <img
                          src={`${process.env.REACT_APP_STATIC_URL}${existingLogoUrl}`}
                          alt="Current logo"
                          style={{ maxHeight: 80, maxWidth: 200, objectFit: "contain" }}
                        />
                        <div>
                          <small className="d-block text-muted">Current logo</small>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger mt-1"
                            onClick={() => {
                              setExistingLogoUrl(null);
                              setClearLogo(true);
                            }}
                          >
                            Remove Logo
                          </button>
                        </div>
                      </div>
                    )}

                    {logoPreview && (
                      <div className="logo-preview mb-2 d-flex align-items-center gap-3">
                        <img
                          src={logoPreview}
                          alt="New logo preview"
                          style={{ maxHeight: 80, maxWidth: 200, objectFit: "contain" }}
                        />
                        <div>
                          <small className="d-block text-muted">New logo (pending upload)</small>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary mt-1"
                            onClick={() => {
                              setFieldValue("logo_file", null);
                              setLogoPreview(null);
                              clearFileInput();
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}

                    <div
                      className="logo-upload-dropzone"
                      onClick={() => fileInputRef.current?.click()}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files?.[0] || null;
                        if (file) {
                          if (!ALLOWED_LOGO_TYPES.includes(file.type)) {
                            setLogoError('Invalid file type. Only JPEG, PNG, WebP and SVG are accepted.');
                            return;
                          }
                          if (file.size > MAX_LOGO_SIZE) {
                            setLogoError(`File too large (${(file.size / 1024 / 1024).toFixed(1)}MB). Maximum 5MB allowed.`);
                            return;
                          }
                          setLogoError(null);
                          setFieldValue("logo_file", file);
                          setLogoPreview(URL.createObjectURL(file));
                        }
                      }}
                    >
                      <div className="logo-upload-icon">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#8b8fca" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                          <polyline points="17 8 12 3 7 8"/>
                          <line x1="12" y1="3" x2="12" y2="15"/>
                        </svg>
                      </div>
                      <div className="logo-upload-text">
                        <strong>Click to upload</strong> or drag and drop
                      </div>
                      <div className="logo-upload-hint">JPEG, PNG, WebP, SVG · Max 5MB</div>
                    </div>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/jpeg,image/png,image/webp,image/svg+xml"
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const file = e.target.files?.[0] || null;
                        if (file) {
                          if (!ALLOWED_LOGO_TYPES.includes(file.type)) {
                            setLogoError('Invalid file type. Only JPEG, PNG, WebP and SVG are accepted.');
                            clearFileInput();
                            return;
                          }
                          if (file.size > MAX_LOGO_SIZE) {
                            setLogoError(`File too large (${(file.size / 1024 / 1024).toFixed(1)}MB). Maximum 5MB allowed.`);
                            clearFileInput();
                            return;
                          }
                          setLogoError(null);
                        }
                        setFieldValue("logo_file", file);
                        setLogoPreview(file ? URL.createObjectURL(file) : null);
                      }}
                    />
                    {logoError && (
                      <div className="text-danger mt-1"><small>{logoError}</small></div>
                    )}
                  </div>
                </div>
              )}

              {/* Buttons */}
              <div className="button-group d-flex align-items-center">
                <button type="submit" className="btns">
                  {isEdit ? "Update Building" : "Add Building"}
                </button>
                <button type="reset" className="btns cancel-btns">
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CreateBuilding;
